import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-element__content" }
const _hoisted_2 = {
  key: 0,
  class: "form-element__buttons-offset-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: _normalizeClass(["form-element", { 'form-element--has-buttons': _ctx.hasButtons, 'form-element--is-loading': _ctx.loading }]),
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.hasButtons)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([{ 'form-element__buttons--has-offset': _ctx.buttonsOffset }, "form-element__buttons"])
        }, [
          (_ctx.buttonsOffset)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "buttons")
              ]))
            : _renderSlot(_ctx.$slots, "buttons", { key: 1 })
        ], 2))
      : _createCommentVNode("", true)
  ], 34))
}